<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          {{ isUpdateMode == true ? $t('update-btn') : $t('save-btn') }}
        </v-card-title>
        <form>
          <v-flex xs12 sm4>
            <v-text-field v-if="isUpdateMode" v-model="storeCode" label="店舗コード" disabled></v-text-field>
            <v-text-field
              v-if="!isUpdateMode"
              v-model="storeCode"
              label="店舗コード"
              v-validate="'required|max:20|alpha_dash'"
              :counter="20"
              :error-messages="errors.collect('storeCode')"
              data-vv-name="storeCode"
            ></v-text-field>
          </v-flex>
          <v-flex sm8>
            <v-text-field
              v-model="storeName"
              label="店舗名"
              v-validate="'required|max:40'"
              :counter="40"
              :error-messages="errors.collect('storeName')"
              data-vv-name="storeName"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-select
              v-model="selectSupplier"
              :items="suppliers"
              label="取引先選択"
              item-text="supplierName"
              item-value="supplierCode"
              :sort-by="['supplierCode']"
              :sort-desc="[false]"
              v-on:change="changedSupplier(`${selectSupplier.supplierCode}`)"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-select
              v-model="selectBrand"
              :items="brands"
              label="ブランド名選択"
              item-text="brandName"
              item-value="brandId"
              :sort-by="['brandId']"
              :sort-desc="[false]"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm8>
            <v-select
              v-model="selectPrefecture"
              :items="prefectures"
              label="都道府県"
              item-text="prefectureName"
              item-value="prefectureCode"
              :sort-by="['prefectureCode']"
              :sort-desc="[false]"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm8>
            <v-text-field
              v-model="rfidSerialNumber"
              label="RFID Serial number"
              v-validate="'max:50'"
              :counter="50"
              :error-messages="errors.collect('rfidSerialNumber')"
              data-vv-name="rfidSerialNumber"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-radio-group v-model="isSalesperson" :mandatory="false" label="販売員有無" row>
              <v-radio label="あり" value="1"></v-radio>
              <v-radio label="なし" value="0"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-switch
            label="自動発注を有効にする"
            color="orange"
            value="1"
            v-if="isUpdateMode"
            hide-details
            v-model="isAutoOrder"
          ></v-switch>

          <v-switch
            label="店舗情報を無効にする"
            color="deep-purple"
            value="1"
            v-if="isUpdateMode"
            hide-details
            v-model="isDeleted"
          ></v-switch>

          <div style="height: 55px;"></div>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-btn
                block
                :color="isUpdateMode == true ? 'primary' : 'green'"
                dark
                @click="isUpdateMode == true ? updateStore() : newStore()"
                :loading="loading2"
                :disabled="loading2"
              >
                <v-icon dark left>
                  {{ isUpdateMode == true ? 'save' : 'create' }}
                </v-icon>
                店舗データを{{ isUpdateMode == true ? $t('update-btn') : $t('save-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>

          <div style="height: 35px;"></div>
        </form>
      </v-container>
    </v-card>

    <div style="height: 55px;"></div>
    <v-card v-if="isUpdateMode">
      <v-container>
        <v-card-title class="title-highlight">
          取扱商品一覧
        </v-card-title>

        <v-layout row span justify-space-between>
          <v-flex sm4>
            <v-select
              v-model="selectedItemCategory"
              :items="itemCategories"
              label="商品カテゴリ"
              item-text="itemCategoryName"
              item-value="itemCategoryId"
              :sort-by="['itemCategoryId']"
              :sort-desc="[false]"
              @change="changeItemCategory()"
            ></v-select>
          </v-flex>

          <v-flex sm6>
            <v-select
              v-model="selectedStoreCode"
              :items="handlingItemsByStore"
              label="他店舗データのコピー"
              item-text="storeName"
              item-value="storeCode"
              @change="readHandlingItems(selectedStoreCode.storeCode)"
              return-object
              autocomplete
            ></v-select>
          </v-flex>
        </v-layout>
        <v-switch
          v-model="handlingItem"
          label="取扱商品のみ表示する"
          color="green"
          @change="changeHandlingItem()"
        ></v-switch>

        <v-data-table
          :headers="headers"
          :items="shopsItems"
          class="elevation-1"
          :customFilter="customFilter"
          :search="multipleSearchObj"
          hide-actions
        >
          <!-- TODO 全選択の場合はselect-allとv-model="selected"を実装し、watchさせる -->
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <tr              
              v-bind:class="{
                'deleted-class-name': props.item.isDeleted == '1' ? true : false               
              }"
            >
              <td class="text-xs-left" style="width: 80px;">
                <v-checkbox v-model="props.item.isHandling" primary hide-details></v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
              <td class="text-xs-left">{{ props.item.itemName }}</td>
              <td class="text-xs-left">{{ props.item.janCode }}</td>
            </tr>
          </template>
        </v-data-table>
        <br />

        <!-- 버튼 영역 -->
        <div class="footer-btns">
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-store-maintenance' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
          <v-btn block color="primary" dark @click="updateStoreItems()">
            <v-icon dark left>save</v-icon>取扱商品を更新する
          </v-btn>
          <v-btn block color="error" dark v-if="isUpdateMode" @click=deleteItem()>
            <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>delete</v-icon>
            完全削除する
          </v-btn>
        </div>
      </v-container>
    </v-card>   
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
// import { fileURLToPath } from 'url'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this

    this.storeCode = this.$route.params.storeCode

    ServerApiCallService.suppliersByStatus()
      .then(response => {
        thisObj.suppliers = response.data.suppliers
        thisObj.suppliers.unshift({
          supplierCode: '#',
          supplierName: '選択してください'
        })
        // 初期表示時の
        thisObj.loading = false // 初期表示時の TODO
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

    ServerApiCallService.prefecture()
      .then(response => {
        thisObj.prefectures = response.data.prefectures
        thisObj.prefectures.unshift({
          prefectureCode: '#',
          prefectureName: '選択してください'
        })
        // 初期表示時の
        thisObj.loading = false // 初期表示時の TODO
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

    if (this.storeCode != null) {
      console.log('更新モード')
      this.isUpdateMode = true
      // getItem on udpate
      let storesRequest = { storeCode: this.storeCode }

      ServerApiCallService.store(storesRequest)
        .then(response => {
          thisObj.storeCode = response.data.store.storeCode
          thisObj.storeName = response.data.store.storeName
          thisObj.selectSupplier = {
            supplierCode: response.data.store.supplierCode
          }
          thisObj.brands = this.changedSupplier(
            thisObj.selectSupplier.supplierCode
          )
          thisObj.selectBrand = {
            brandId: response.data.store.brandId
          }
          thisObj.isSalesperson = response.data.store.isSalesperson
          thisObj.isDeleted = response.data.store.isDeleted
          thisObj.rfidSerialNumber = response.data.store.rfidSerialNumber
          thisObj.isAutoOrder = response.data.store.isAutoOrder
          thisObj.selectPrefecture = {
            prefectureCode: response.data.store.prefecture
          }

          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    } else {
      console.log('登録モード')
      this.isUpdateMode = false
    }

    ServerApiCallService.itemCategoriesByStatus()
      .then(response => {
        console.log('completed item categories')
        thisObj.itemCategories = response.data.itemCategories
        thisObj.itemCategories.unshift({
          itemCategoryId: '#',
          itemCategoryName: '全て'
        })
        // 初期表示時の
        thisObj.loading = false // 初期表示時の TODO
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

    ServerApiCallService.storesItems({ storeCode: this.storeCode })
      .then(response => {

        thisObj.shopsItems = response.data.shopsItems
        thisObj.shopsItems.forEach(function(val) {
          // 表示する商品IDをdispShopsItemsIDsに保持する
          thisObj.dispShopsItemsIDs.push(val.itemCode)
        })

        thisObj.handlingItemsByStore = response.data.stores
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    changedSupplier(supplierCode) {
      let thisObj = this

      let request = {
        supplierCode: supplierCode
      }

      ServerApiCallService.brandsBySupplierCode(request)
        .then(response => {
          
          thisObj.brands = response.data.brands
          thisObj.brands.unshift({
            brandId: '#',
            brandName: '選択してください'
          })
          // 初期表示時の
          thisObj.loading = false // 初期表示時の TODO
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    changeItemCategory() {
      console.log('change item category')
      let localDispOnlyHandling = this.multipleSearchObj.dispOnlyHandling
      this.multipleSearchObj = null
      this.multipleSearchObj = {
        itemCategoryId: this.selectedItemCategory, // TODO v-modelはイマイチな気がしてきた。いつあ見直さざるを得ない
        dispOnlyHandling: localDispOnlyHandling
      }
    },
    changeHandlingItem() {
      console.log('change handling item')
      let localItemCategoryId = this.multipleSearchObj.itemCategoryId
      this.multipleSearchObj = null
      this.multipleSearchObj = {
        itemCategoryId: localItemCategoryId, // TODO v-modelはイマイチな気がしてきた。いつあ見直さざるを得ない
        dispOnlyHandling: this.handlingItem
      }
    },
    newStore() {
      console.log('new store')
      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        storeCode: this.storeCode,
        storeName: this.storeName,
        supplierCode: this.selectSupplier.supplierCode,
        brandId: this.selectBrand.brandId,
        isSalesperson: this.isSalesperson,
        isDeleted: this.isDeleted == null ? '0' : this.isDeleted,
        rfidSerialNumber: this.rfidSerialNumber,
        isAutoOrder: this.isAutoOrder,
        prefecture: this.selectPrefecture.prefectureCode
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-store-maintenance'
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          return
        }

        if (thisObj.selectSupplier.supplierCode === '#') {
          thisObj.$parent.$parent.$parent.showErrorDialog(
            '取引先を選択してください'
          )
          thisObj.loading2 = false
          return
        }
        if (thisObj.selectBrand.brandId === '#') {
          this.$parent.$parent.$parent.showErrorDialog(
            'ブランドを選択してください'
          )
          thisObj.loading2 = false
          return
        }
        if (this.selectPrefecture.prefectureCode === '') {
          this.$parent.$parent.$parent.showErrorDialog(
            '都道府県を選択してください'
          )
          thisObj.loading2 = false
          return
        }

        ServerApiCallService.storesPost(request, sendContext)
          .then(() => {
            console.log('completed new stores')
            thisObj.loading2 = false
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    updateStore() {
      console.log('update store')

      let thisObj = this
      thisObj.loading2 = true

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          return
        }
        console.log(thisObj.selectSupplier.supplierCode)
        console.log(thisObj.selectSupplier.supplierName)
        if (
          thisObj.selectSupplier.supplierCode === '#' ||
          thisObj.selectSupplier.supplierCode === '' ||
          thisObj.selectSupplier.supplierName === ''
        ) {
          thisObj.$parent.$parent.$parent.showErrorDialog(
            '取引先が選択されていません'
          )
          thisObj.loading2 = false
          return
        }
        console.log(thisObj.selectBrand.brandId)
        if (
          thisObj.selectBrand.brandId === '#' ||
          thisObj.selectBrand.brandId === 0
        ) {
          this.$parent.$parent.$parent.showErrorDialog(
            'ブランドが選択されていません'
          )
          thisObj.loading2 = false
          return
        }

        // TODO 現状isDeletedがfalseの場合nullで飛ぶ
        let request = {
          storeCode: this.storeCode,
          storeName: this.storeName,
          supplierCode: this.selectSupplier.supplierCode,
          brandId: this.selectBrand.brandId,
          isSalesperson: this.isSalesperson,
          isDeleted: this.isDeleted == null ? '0' : this.isDeleted,
          rfidSerialNumber: this.rfidSerialNumber,
          isAutoOrder: this.isAutoOrder == null ? '0' : this.isAutoOrder,
          prefecture: this.selectPrefecture.prefectureCode
        }

        let sendContext = {
          hasDialogComponent: this.$parent.$parent.$parent,
          forwardNameOnClose: 'admin/new-store-maintenance'
        }

        ServerApiCallService.storesPut(request, sendContext)
          .then(() => {
            console.log('completed new stores')
            thisObj.loading2 = false
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    updateStoreItems() {
      console.log('update storeItems')

      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let dispShopsItems = this.shopsItems.filter(
        items => thisObj.dispShopsItemsIDs.indexOf(items.itemCode) >= 0
      )

      let request = {
        storeCode: this.storeCode,
        shopsItems: dispShopsItems
      }

      ServerApiCallService.storesItemsUpdate(
        request,
        this.$parent.$parent.$parent        
      )
      .then(() => {
        console.log('completed new stores')
        thisObj.loading2 = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
    },
    customFilter(items, search) {
      // 선택된 조건(카테고리 / 取扱商品のみ)에 맞게 테이블에 표시할 상품을 필터링
      let filterlingItems = items.filter(
        item =>
          (search.itemCategoryId === '#' ||
            item.itemCategoryId === search.itemCategoryId) &&
          (!search.dispOnlyHandling ||
            (search.dispOnlyHandling && item.isHandling))
      )

      // 현재 shopsItems에서 isHandling == true 인 상품만 dispShopsItemsIDs에 유지
      // → 카테고리 바꾸거나 검색을 바꿔도 선택된 상품이 절대로 사라지지 않도록 보존
      this.dispShopsItemsIDs = this.shopsItems
      .filter(i => i.isHandling)             // 체크된 상품만 유지
      .map(i => i.itemCode);

      return filterlingItems
    },
    readHandlingItems(selectedStoreCode) {
      let thisObj = this

      thisObj.shopsItems.forEach(function(shopsItem) {
        shopsItem.isHandling = false
      })

      ServerApiCallService.copyStoresItems({ storeCode: selectedStoreCode })
        .then(response => {
          response.data.itemCodes.forEach(function(itemCode) {
            // 表示する商品IDをdispShopsItemsIDsに保持する
            thisObj.dispShopsItemsIDs.push(itemCode)
            thisObj.shopsItems.forEach(function(shopsItem) {
              if (shopsItem.itemCode == itemCode) {
                shopsItem.isHandling = true
              }
            })
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    deleteItem() {
      if (!confirm("店舗と店舗に登録されている全ての商品も削除されますが\nよろしいですか")) {
        return;
      }
      
      let request = {
        storeCode: this.storeCode,
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-store-maintenance'
      }

      let dispShopsItems = this.shopsItems.filter(
        items => this.dispShopsItemsIDs.indexOf(items.itemCode) >= 0
      )

      // if (dispShopsItems.length > 0) {
      //   alert("店舗の商品を全て削除してください")
      //   return false;
      // }      
      
      ServerApiCallService.storeDelete(request, sendContext)
        .then(() => {
          console.log('completed delete store')
          this.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })      
    },
    // submit() {
    //   this.$validator.validateAll()
    // }
  },

  watch: {
    // selected: function(val) {
    //   // 全選択を有効にする場合のfunction{
    //   // 要件にないので実相はしない
    // }
  },
  data() {
    return {
      isUpdateMode: this.$route.params.isUpdateMode,
      isHandling: true,
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,
      selected: [],
      storeCode: this.$route.params.storeCode,
      storeName: '',
      handlingItemsByStore: [],
      selectedStoreCode: '',
      suppliers: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て'
      },
      rfidSerialNumber: '',
      brands: [],
      selectBrand: {
        brandId: '#',
        brandName: '全て'
      },
      prefectures: [],
      selectPrefecture: {
        prefectureCode: '',
        prefectureName: '',
        
      },
      isSalesperson: '1',
      isDeleted: '0',
      isAutoOrder: '0',
      prefecture: '',

      // storeCode: this.$route.params.storeInfo.storeCode,
      // paramSupplierCode: this.$route.params.storeInfo.supplierCode,
      name: '',
      checkbox: null,

      itemCategories: [],
      selectedItemCategory: {
        itemCategoryId: '#',
        itemCategoryName: '全て'
      },

      handlingItem: false, // 취급상품 표시

      multipleSearchObj: {
        itemCategoryId: '#',
        dispOnlyHandling: false
      },

      headers: [
        {
          text: '選択',
          align: 'left',
          value: 'selectSupplier',
          width: '50px',
          fixed: true
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'categoryName',
          width: '200px',
          fixed: true
        },
        {
          text: '商品名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '250px',
          fixed: true
        },
        {
          text: 'JANコード',
          align: 'left',
          sortable: false,
          value: 'supplierCode',
          width: '100px'
        }
      ],
      shopsItems: [],
      dispShopsItemsIDs: []
    }
  }
}
</script>

<style>
.deleted-class-name {
  background-color: #b3b3b3;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
